/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-15 11:19:53
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 00:26:03
 * @FilePath: /wemeet-web-activity/src/pages/questions/utils/validateForm.ts
 * @Description: 校验表单是否可以提交
 */
import { QuestionType } from "../type/index";
import { Validator } from "../../PayEnd/component/phoneInput/validator";
const getRealPhone = (phone = '') => {
  const tag = phone?.indexOf?.(';') > -1 ? ';' : ' ';
  const phoneNum = phone?.split?.(tag)?.[1];
  return phoneNum;
};
export const validatePhone = (phone = '', notEmpty = false) => {
  const tag = phone?.indexOf?.(';') > -1 ? ';' : ' ';
  const phoneNum = phone?.split?.(tag)?.[1];
  if (!phoneNum && !notEmpty) {
    return true;
  }
  if (phone?.startsWith?.('86') || phone?.startsWith?.('+86')) {
    return Validator.isPhone(phoneNum);
  }
  return /^[0-9]*$/.test(phoneNum);
};
const validateForm = (list, userPhone) => {
  const len = list.length;
  if (len === 0) {
    return false;
  }
  let i = 0;
  for (i; i < len; i++) {
    const item = list[i];
    if (item.error || item.is_required && !item.answer) {
      return false;
    }
    // 手机号，打开了验证，并且没有验证码的，就需要验证一下
    if (item.question_type === QuestionType.PHONE) {
      const phone = getRealPhone(item.answer);

      // 必填项未填时候需要校验不通过
      if (item.is_required && !phone) {
        return false;
      }
      if (!!userPhone && phone !== userPhone && (item.checkPhone || typeof item.checkPhone === 'undefined' && item.open_check === 1) && validatePhone(item.answer, true) && !item.verification_code && (item.answer?.startsWith?.('86') || item.answer?.startsWith?.('+86'))) {
        return false;
      }
    }
    if (item.question_type === QuestionType.PHONE && !validatePhone(item.answer)) {
      return false;
    }
  }
  return true;
};
export default validateForm;